module.exports = __webpack_public_path__ + "img/kfWx@2x.b6b875db.png";